import { AdminToolSkeleton } from '../../AdminToolSkeleton';
import { PaginatedTable, PaginatedTableProps } from '@act/storybook';
import { IndexChildContainer } from 'react-components/member-index/indexContainer';
import { getAllClients } from 'redux/slices/clientSlice';
import { messageTemplatesSelectors } from 'redux/slices/messageTemplatesSlice';
import { clientAppSelectors } from 'redux/slices/clientSlice';
import { useParams } from 'react-router-dom';
import { TemplateTableColumns } from './TemplateColumns';
import { useEffect, useMemo, useState } from 'react';
import { useAppDispatch } from 'redux/store-hooks';
import { useAdminRouting } from 'react-components/admin-dashboard/AdminTools.utils';
import { MessageTemplateAdminDto } from '@act/shared/data-transfer-objects';
import { MessageTemplateCreateEdit } from './MessageTemplateCreateEdit';

export const MessageTemplatesTable = () => {
  const dispatch = useAppDispatch();
  const [templateEdit, setTemplateEdit] = useState(false);
  const [selectedTemplate, setSelectedTemplate] =
    useState<MessageTemplateAdminDto | null>(null);
  const [createNewOpen, setCreateNewOpen] = useState(false);
  const { id: id } = useAdminRouting();

  const { categoryId: categoryId } = useParams();
  useEffect(() => {}, [categoryId]);

  const setFormOpen = (value: boolean) => {
    if (!value) {
      setTemplateEdit(false);
      setSelectedTemplate(null);
    }
  };

  const messageTemplates = Object.values(
    messageTemplatesSelectors.useSelectAll().entities
  );
  const allClients = clientAppSelectors.useSelectAllClients();
  const clientList = useMemo(
    () => allClients.ids.map(id => allClients.entities[id]),
    [allClients]
  );

  useEffect(() => {
    if (clientList.length === 0) {
      dispatch(getAllClients({}));
    }
  }, []);

  const templates = useMemo(() => {
    return messageTemplates.flatMap(category =>
      category.templates.map(template => ({
        ...template,
        template_clients: (template.template_clients || []).map(
          tc => tc.clientId
        ),
      }))
    ) as MessageTemplateAdminDto[];
  }, [messageTemplates]);
  const category_id = id ? Number(id) : categoryId ? Number(categoryId) : null;

  const filteredTemplates = useMemo(() => {
    return categoryId
      ? templates.filter(template => template.categoryId === category_id)
      : templates.filter(template => template.categoryId === category_id);
  }, [categoryId, templates]);

  const MESSAGE_CATEGORIES_ADMIN_TABLE_PROPS: PaginatedTableProps<MessageTemplateAdminDto> =
    {
      data: filteredTemplates,
      columnConfig: TemplateTableColumns(
        clientList,
        messageTemplates.find(category => category.id === Number(id))?.name
      ),
      inMemoryPagination: true,
      onRowClick: template => {
        setSelectedTemplate(template);
        setTemplateEdit(true);
      },
    };

  return (
    <>
      <AdminToolSkeleton
        title={`${
          messageTemplates.find(category => category.id === category_id)?.name
        } Templates`}
        toolDescription="Message templates can be viewed and updated here."
        buttonContent="Add New Message Template"
        variant="contained"
        onClick={() => setCreateNewOpen(true)}
      >
        <IndexChildContainer>
          <PaginatedTable {...MESSAGE_CATEGORIES_ADMIN_TABLE_PROPS} />
        </IndexChildContainer>
        {(createNewOpen || templateEdit) && (
          <MessageTemplateCreateEdit
            setOpen={createNewOpen ? setCreateNewOpen : setFormOpen}
            open={createNewOpen || templateEdit}
            categories={messageTemplates}
            isEdit={templateEdit}
            selectedTemplate={templateEdit ? selectedTemplate : undefined}
          />
        )}
      </AdminToolSkeleton>
    </>
  );
};
